// mutations
const RESTAURANT_REQUESTS_ALL = (state, restaurantRequests) => {
  if (restaurantRequests.code === 1) {
    state.restaurantRequests = restaurantRequests.data
    state.status = 'success'
  } else {
    alert(restaurantRequests.message)
    state.status = 'error'
  }
}

const RESTAURANT_REQUESTS_FORM = (state, restaurantRequests) => {
  if (restaurantRequests.code === 1) {
    state.restaurantRequests = restaurantRequests.data
    state.status = 'success'
  } else {
    alert(restaurantRequests.message)
    state.status = 'error'
  }
}

const RESTAURANT_REQUESTS_SHOW = (state, restaurantRequests) => {
  if (restaurantRequests.code === 1) {
    state.restaurantRequests = restaurantRequests.data
    state.status = 'success'
  } else {
    alert(restaurantRequests.message)
    state.status = 'error'
  }
}

const RESTAURANT_REQUESTS_CREATE = (state, restaurantRequests) => {
  if (restaurantRequests.code === 1) {
    state.restaurantRequests = restaurantRequests.data
    state.status = 'success'
  } else {
    alert(restaurantRequests.message)
    state.status = 'error'
  }
}

const RESTAURANT_REQUESTS_UPDATE = (state, restaurantRequests) => {
  if (restaurantRequests.code === 1) {
    state.restaurantRequests = restaurantRequests.data
    state.status = 'success'
  } else {
    alert(restaurantRequests.message)
    state.status = 'error'
  }
}

const RESTAURANT_REQUESTS_DELETE = (state, restaurantRequests) => {
  if (restaurantRequests.code === 1) {
    state.restaurantRequests = restaurantRequests.data
    state.status = 'success'
  } else {
    alert(restaurantRequests.message)
    state.status = 'error'
  }
}

const RESTAURANT_REQUESTS_QRACCES_LIST = (state, restaurantRequests) => {
  if (restaurantRequests.code === 1) {
    state.restaurantRequests = restaurantRequests.data
    state.status = 'success'
  } else {
    state.restaurantRequests = restaurantRequests.data
    // alert(restaurantRequests.message)
    state.status = 'error'
  }
}

const RESTAURANT_REQUESTS_QRACCES_TURNS = (state, data) => {
  state.restaurantRequests.turns = data
}

export default {
  RESTAURANT_REQUESTS_ALL,
  RESTAURANT_REQUESTS_FORM,
  RESTAURANT_REQUESTS_SHOW,
  RESTAURANT_REQUESTS_CREATE,
  RESTAURANT_REQUESTS_UPDATE,
  RESTAURANT_REQUESTS_DELETE,
  RESTAURANT_REQUESTS_QRACCES_LIST,
  RESTAURANT_REQUESTS_QRACCES_TURNS
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/requests/mutations.js